import { tap } from '@helo/utils'
import axios from 'axios'

import { AppStore, useAppStore } from './appStore'
import { Organization } from './auth/AuthSlice.types'
import { AuthSliceParts } from './auth/authSlice.parts'
import { PersistenceSliceActions } from './persistence/persistenceSlice.actions'

export const setupAxiosInterceptors = () =>
  tap(<T extends AppStore>(store: T) => {
    axios.interceptors.response.use(null, error => {
      if (error.response?.status === 401) {
        AuthSliceParts.loginWithRedirect({
          returnTo: `${window.location.pathname}${window.location.search}`,
        })(store)
      }
    })
    axios.interceptors.request.use(request => {
      const url = request.url
      if (!url) return request

      // notifications doesn't have a payload. likely GET.
      // getting selected organization directly from the store to bypass async update wait time.
      if (typeof request.data === 'object') {
        request.data.customerName = (
          PersistenceSliceActions.getPersistenceItemValue<Organization>(
            'selectedOrganization',
          )(useAppStore.getState()) as Organization
        ).name
      }
      return request
    }, null)
  })

export const redirectToAuthProvidedUrl = () =>
  tap(<T extends AppStore>(store: T) => {
    const redirectTo = store.auth.redirectTo!
    if (
      redirectTo &&
      `${window.location.pathname}${window.location.search}` !== redirectTo
    ) {
      store.router.router!.navigate(redirectTo, { replace: true })
    }
  })
